export default __webpack_public_path__ + "static/media/p6.b51c0fb6.jpeg";